import React from 'react'
import { connect } from 'react-redux'

const mapStateToProps = (state, ownProps) => {
    return {
        commission: state.commissions.find(c => c.id === Number(ownProps.params.commissionId))
    }
}

const ViewCommission = ({ commission }) => {
    return (
        <div>
            <h1>View a Commission</h1>
            {commission.get('amount')}
        </div>
    )
}

export default connect(mapStateToProps)(ViewCommission)
